"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getField = void 0;
const reactiveState_1 = require("../../reactiveState");
const getField = ({ state, onChange, onBlur, }) => function Field({ children, name }) {
    const [{ values, schemaErrors, touchedFields, dirtyFields }] = (0, reactiveState_1.useReactiveState)(state);
    return children({
        name,
        onChange,
        onBlur,
        value: values[name] ?? '',
        error: schemaErrors[name],
        touched: !!touchedFields[name],
        dirty: !!dirtyFields[name],
    });
};
exports.getField = getField;
//# sourceMappingURL=getField.js.map